import { Capacitor } from '@capacitor/core';
import { isStandalonePwa } from '@/utils/pwaStandalone';
import { detectWebBrowser, isIosPlatform } from '@/utils/webPlatform';

export const KITCHEN_PUSH_OPT_OUT_KEY = 'ollaa_kitchen_push_opt_out';

export const getInstallTutorialVariant = () => {
  if (Capacitor.isNativePlatform()) return 'none';
  if (isStandalonePwa()) return 'none';
  const browser = detectWebBrowser();
  if (isIosPlatform()) {
    if (browser === 'safari-ios') return 'ios-safari';
    return 'ios-chrome';
  }
  if (browser === 'samsung-android') return 'samsung-android';
  if (browser === 'chrome-android' || browser === 'firefox-android') {
    return 'android-chromium';
  }
  return 'none';
};

export const hasKitchenPushOptOut = () => {
  try {
    return localStorage.getItem(KITCHEN_PUSH_OPT_OUT_KEY) === '1';
  } catch {
    return false;
  }
};

export const setKitchenPushOptOut = (value) => {
  try {
    if (value) localStorage.setItem(KITCHEN_PUSH_OPT_OUT_KEY, '1');
    else localStorage.removeItem(KITCHEN_PUSH_OPT_OUT_KEY);
  } catch {
    // ignore
  }
};

export const canProceedFromKitchenPwaStep = () => isStandalonePwa() || hasKitchenPushOptOut();

/** First wizard step — only used in Safari before Home-Screen install. */
export const resolveKitchenSetupStartStep = () => 0;
